// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Map-module__pod_panel_map_container_play___hk2R2 {
    position: static;
    inset: 0;
}

.Map-module__map_container___wgWAH {
    position: relative;
    inset: 0;
    height: 100% !important;
    width: 100%;
}

.Map-module__wrapper___ZpaaY {
    flex: 1;
    position: relative;
    height: 100%;
}

.Map-module__legend___pGId6 {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 4px;
    margin: 10px;
    z-index: 1;
}

/* Save Map Button Styles */
.Map-module__saveMapButton___bd5Hx {
    position: absolute;
    top: 20px;
    right: 20px;
    background-color: var(--bmo-primary-color-mint);
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease;
}

    .Map-module__saveMapButton___bd5Hx:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

    .Map-module__saveMapButton___bd5Hx:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }

/* Modal Styles */
.Map-module__modalOverlay___YAxhI {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.Map-module__modal___c4JEF {
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

    .Map-module__modal___c4JEF h3 {
        margin-top: 0;
        margin-bottom: 16px;
        color: #111827;
        font-size: 1.25rem;
    }

.Map-module__urlContainer___OxYdb {
    display: flex;
    margin: 16px 0;
}

.Map-module__urlInput___VfOgi {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    background-color: #f9fafb;
}

.Map-module__copyButton___m3jsx {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    border: none;
    padding: 8px 16px;
    /* border-radius: 0 4px 4px 0; */
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.3s;
}

    .Map-module__copyButton___m3jsx:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.Map-module__modalNote___rEVhH {
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 20px;
}

.Map-module__modalButtons___Hy6G5 {
    display: flex;
    justify-content: flex-end;
}

.Map-module__closeButton___OisOQ {
    background-color: #e5e7eb;
    color: #111827;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.3s;
}

    .Map-module__closeButton___OisOQ:hover {
        background-color: #d1d5db;
    }

.Map-module__panelLegend___zKC1A {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    margin-top: 5px;
}

.Map-module__legendDotGreen___vmk37,
.Map-module__legendDotBlue___ZMddC,
.Map-module__legendDotYellow___mxojU,
.Map-module__legendDotPink___DuVYg,
.Map-module__legendDotPurple___ZnDLK,
.Map-module__legendDotOrange___xoOpX {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 4px;
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.Map-module__legendDotGreen___vmk37 {
    background-color: green;
}

.Map-module__legendDotBlue___ZMddC {
    background-color: blue;
}

.Map-module__legendDotYellow___mxojU {
    background-color: yellow;
}

.Map-module__legendDotOrange___xoOpX {
    background-color: orange;
}

.Map-module__legendDotPink___DuVYg {
    background-color: pink;
}

.Map-module__legendDotPurple___ZnDLK {
    background-color: purple;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Map/Map.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,+CAA+C;IAC/C,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,sCAAsC;AAC1C;;IAEI;QACI,oDAAoD;IACxD;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;AAEJ,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,wCAAwC;AAC5C;;IAEI;QACI,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;;;IAMI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["#pod_panel_map_container_play {\n    position: static;\n    inset: 0;\n}\n\n.map_container {\n    position: relative;\n    inset: 0;\n    height: 100% !important;\n    width: 100%;\n}\n\n.wrapper {\n    flex: 1;\n    position: relative;\n    height: 100%;\n}\n\n.legend {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    padding: 10px;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    border-radius: 4px;\n    margin: 10px;\n    z-index: 1;\n}\n\n/* Save Map Button Styles */\n.saveMapButton {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 8px;\n    font-weight: bold;\n    cursor: pointer;\n    z-index: 10;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    transition: background-color 0.3s ease;\n}\n\n    .saveMapButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n    .saveMapButton:disabled {\n        background-color: #ccc;\n        cursor: not-allowed;\n    }\n\n/* Modal Styles */\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal {\n    background-color: white;\n    border-radius: 8px;\n    padding: 24px;\n    max-width: 500px;\n    width: 90%;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n    .modal h3 {\n        margin-top: 0;\n        margin-bottom: 16px;\n        color: #111827;\n        font-size: 1.25rem;\n    }\n\n.urlContainer {\n    display: flex;\n    margin: 16px 0;\n}\n\n.urlInput {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 4px 0 0 4px;\n    font-size: 14px;\n    background-color: #f9fafb;\n}\n\n.copyButton {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    /* border-radius: 0 4px 4px 0; */\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n    .copyButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.modalNote {\n    color: #6b7280;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n.modalButtons {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.closeButton {\n    background-color: #e5e7eb;\n    color: #111827;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n    .closeButton:hover {\n        background-color: #d1d5db;\n    }\n\n.panelLegend {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 10px;\n    margin-top: 5px;\n}\n\n.legendDotGreen,\n.legendDotBlue,\n.legendDotYellow,\n.legendDotPink,\n.legendDotPurple,\n.legendDotOrange {\n    height: 10px;\n    width: 10px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.legendDotGreen {\n    background-color: green;\n}\n\n.legendDotBlue {\n    background-color: blue;\n}\n\n.legendDotYellow {\n    background-color: yellow;\n}\n\n.legendDotOrange {\n    background-color: orange;\n}\n\n.legendDotPink {\n    background-color: pink;\n}\n\n.legendDotPurple {\n    background-color: purple;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pod_panel_map_container_play": `Map-module__pod_panel_map_container_play___hk2R2`,
	"map_container": `Map-module__map_container___wgWAH`,
	"wrapper": `Map-module__wrapper___ZpaaY`,
	"legend": `Map-module__legend___pGId6`,
	"saveMapButton": `Map-module__saveMapButton___bd5Hx`,
	"modalOverlay": `Map-module__modalOverlay___YAxhI`,
	"modal": `Map-module__modal___c4JEF`,
	"urlContainer": `Map-module__urlContainer___OxYdb`,
	"urlInput": `Map-module__urlInput___VfOgi`,
	"copyButton": `Map-module__copyButton___m3jsx`,
	"modalNote": `Map-module__modalNote___rEVhH`,
	"modalButtons": `Map-module__modalButtons___Hy6G5`,
	"closeButton": `Map-module__closeButton___OisOQ`,
	"panelLegend": `Map-module__panelLegend___zKC1A`,
	"legendDotGreen": `Map-module__legendDotGreen___vmk37`,
	"legendDotBlue": `Map-module__legendDotBlue___ZMddC`,
	"legendDotYellow": `Map-module__legendDotYellow___mxojU`,
	"legendDotPink": `Map-module__legendDotPink___DuVYg`,
	"legendDotPurple": `Map-module__legendDotPurple___ZnDLK`,
	"legendDotOrange": `Map-module__legendDotOrange___xoOpX`
};
export default ___CSS_LOADER_EXPORT___;
